export default __webpack_public_path__ + "static/grow-illustration-be732b6146bebbb7decd7b31680301a2.svg";